export default __webpack_public_path__ + "static/media/1.cd87ba36.jpg";